import { IconChevronRight } from '@koleso-icons';
import { Badge, Button, ButtonSize, ButtonThemes, LinkColors, MyLink, SkeletonLoading, WrapperLk } from '@app/shared';
import { useWindowSizing } from '@hooks/useSizeWindow';
import { useCallback, useEffect } from 'react';
import { fetchUserWarranty, getIsLoadedUserWarranty, getUserWarranty, getIsErrorUserWarranty } from '@entities/Warranty';
import { WrapperErrorLkShort } from '@app/shared';
import { useRouter } from 'next/router';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { getDateBySeconds } from '@sharedHelpers/getDateBySeconds';
import IconWarranty from './icons/warranty.svg';
import classNames from 'classnames';

import styles from './ShortInfoUserWarranty.module.scss';

export const ShortInfoUserWarranty = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const isMobile = useWindowSizing(990);
  const isLoaded = useAppSelector(getIsLoadedUserWarranty);
  const warranties = useAppSelector(getUserWarranty);
  const firstWarranty = warranties?.length && warranties[0];
  const isError = useAppSelector(getIsErrorUserWarranty);

  useEffect(() => {
    if (!isLoaded) {
      dispatch(fetchUserWarranty());
    }
  }, []);

  const handlerRoute = useCallback(async () => {
    await router.push('/personal/guaranty/');
  }, []);

  const handlerRouteMobile = useCallback(async () => {
    isMobile && (await router.push('/personal/guaranty/'));
  }, [isMobile]);

  if (isError) {
    return (
      <WrapperLk className={styles.Wrapper} IsMobile={isMobile}>
        <div className={styles.Container}>
          <div className={styles.Title} onClick={handlerRoute}>
            Расширенная гарантия
            <IconChevronRight width={16} height={16} />
          </div>
          <WrapperErrorLkShort error={isError} className={styles.Error} />
        </div>
      </WrapperLk>
    );
  }

  if (!isLoaded) {
    return <SkeletonLoading className={styles.WrapperSkeleton} width={'100%'} height={'100%'} />;
  }

  if (isLoaded && !warranties?.length) {
    return (
      <WrapperLk className={styles.Wrapper} IsMobile={isMobile} onClick={handlerRouteMobile}>
        <div className={styles.Container}>
          <div className={styles.Title} onClick={handlerRoute}>
            Расширенная гарантия
            <IconChevronRight width={16} height={16} />
          </div>
          <div className={styles.WarrantyText}>Бесплатное обслуживание шин после активации гарантии</div>
          {isMobile ? (
            <Button size={ButtonSize.S} themes={isMobile ? ButtonThemes.DarkViolet : ButtonThemes.Violet}>
              Активировать
            </Button>
          ) : (
            <Badge className={styles.Badge}>
              <MyLink color={LinkColors.Black} href="/personal/guaranty/">
                Активировать
              </MyLink>
              <IconChevronRight width={16} height={16} />
            </Badge>
          )}
        </div>
        <IconWarranty className={styles.IconWarranty} width={90} height={90} />
      </WrapperLk>
    );
  }

  return (
    <WrapperLk className={classNames(styles.Wrapper, styles.IsWarranty)} IsMobile={isMobile} onClick={handlerRouteMobile}>
      <div className={styles.Container}>
        <div className={styles.Title} onClick={handlerRoute}>
          Расширенная гарантия
          <IconChevronRight width={16} height={16} />
        </div>
        <div className={styles.NumberWarranty}>№ {firstWarranty.number}</div>
        <div className={styles.WarrantyDate}>до {getDateBySeconds(firstWarranty.dataEnd)}</div>
        <div className={styles.WarrantyBrand}>{firstWarranty.brand}</div>
      </div>
      {warranties.length > 1 && isMobile ? (
        <Badge className={styles.Badge}>+ {warranties.length}</Badge>
      ) : (
        <Button size={ButtonSize.S} themes={isMobile ? ButtonThemes.DarkViolet : ButtonThemes.Violet}>
          <MyLink color={LinkColors.Black} className={styles.ActiveMore} href="/personal/guaranty">
            Активировать ещё
          </MyLink>
        </Button>
      )}
    </WrapperLk>
  );
};
